import i18next, { type i18n, type TFunction } from 'i18next'
import Backend from 'i18next-chained-backend'
import LocalStorageBackend from 'i18next-localstorage-backend' // primary use cache
import HttpApi from 'i18next-http-backend' // fallback xhr load
import { isNonEmptyString } from '@/js/js-utils'

export function initI18next(instance: i18n, lng: string, version: string | null, prefix: string): Promise<TFunction> {
  return instance
    .use(Backend)
    .init({
      lng: lng,
      fallbackLng: 'en',
      debug: false,
      // resources: resources,
      backend: {
        backends: [
          LocalStorageBackend,  // primary
          HttpApi               // fallback
        ],
        backendOptions: [{
          // prefix for stored languages
          prefix: prefix,

          // expiration
          expirationTime: 7*24*60*60*1000,

          // same version for all languages, so the cached fallback language is shared between pages
          defaultVersion: version || undefined,

          // can be either window.localStorage or window.sessionStorage. Default: window.localStorage
          store: window.sessionStorage
        }, {
          loadPath: '/locales/{{lng}}/{{ns}}.json' // xhr load path for my own fallback
        }]
      }
    })
}

document.addEventListener('DOMContentLoaded', (): void => {

  let curLng = document.body.dataset.lng
  if (!isNonEmptyString(curLng)) {
    curLng = 'en'
  }

  let i18nPrefix = 'i18next_res_'
  const prefixMetaEl = document.querySelector('meta[name="i18n-prefix"]')
  if (prefixMetaEl instanceof HTMLMetaElement) {
    i18nPrefix = `${prefixMetaEl.content}_`
  }

  initI18next(i18next, curLng, document.body.dataset.lngV || null, i18nPrefix)
})
